
import { IconBadge } from '@backmarket/design-system'

import translations from './QualityInfo.translations'

export default {
  components: {
    IconBadge,
  },

  computed: {
    translations: () => translations,
  },
}
